import { Button, Card, Col, Form, Table } from 'react-bootstrap';
import {
  CollectionItemType,
  CollectionLevelItem,
  CollectionLevelItemInput,
  CollectionType,
  GetBadgesQuery,
  GetItemsQuery,
} from '../../../../../../__gqltypes__';
import Editvalue from '../../../components/EditValue';
import AddContentPack from '../../../../curation/screens/ContentPackList/AddContentPack';
import SelectAdd from '../../../../devtools/screens/UserView/components/SelectAdd';

type Props = {
  collectionType: CollectionType;
  items: CollectionLevelItem[];
  onChangedItems: (m: CollectionLevelItemInput[]) => void;
  vanityData?: GetItemsQuery;
  badgesData?: GetBadgesQuery;
};

function CollectionLevelComponent({ collectionType, items, onChangedItems, vanityData, badgesData }: Props) {
  const handleRemoveLevel = () => (items.length === 0 ? onChangedItems([]) : onChangedItems(items.slice(0, -1)));
  const handleAddLevel = () => {
    onChangedItems([
      ...items,
      {
        itemId: '',
        itemLevel: 0,
        type: collectionType === CollectionType.MUSIC ? CollectionItemType.PLAYLIST : CollectionItemType.BADGE,
      },
    ]);
  };

  const frameOptions: Record<string, { value: string; searchValue: string }> = {};
  vanityData?.liveOps.profileFrames.list?.forEach((item) => {
    frameOptions[item.id] = {
      value: item.name,
      searchValue: item.name,
    };
  });

  const stickerOptions: Record<string, { value: string; searchValue: string }> = {};
  vanityData?.liveOps.stickers.list?.forEach((item) => {
    stickerOptions[item.id] = {
      value: item.name,
      searchValue: item.name,
    };
  });

  const vinylOptions: Record<string, { value: string; searchValue: string }> = {};
  vanityData?.liveOps.appskins.list?.forEach((item) => {
    vinylOptions[item.id] = {
      value: item.name,
      searchValue: item.name,
    };
  });

  const badgesOptions: Record<string, { value: string; searchValue: string }> = {};
  badgesData?.liveOps.badgeConfigs.list?.forEach((item) => {
    badgesOptions[item.id] = {
      value: item.name,
      searchValue: item.name,
    };
  });

  const subItems = {
    [CollectionItemType.FRAME]: frameOptions,
    [CollectionItemType.STICKER]: stickerOptions,
    [CollectionItemType.VINYL]: vinylOptions,
    [CollectionItemType.BADGE]: badgesOptions,
  };

  const onAdd = (key: string, type: string, itemIndex: number) => {
    let itms: any = [];
    if (type === CollectionItemType.FRAME) {
      itms = vanityData?.liveOps.profileFrames.list ?? [];
    }
    if (type === CollectionItemType.STICKER) {
      itms = vanityData?.liveOps.stickers.list ?? [];
    }
    if (type === CollectionItemType.VINYL) {
      itms = vanityData?.liveOps.appskins.list ?? [];
    }
    if (type === CollectionItemType.BADGE) {
      itms = badgesData?.liveOps.badgeConfigs.list ?? [];
    }
    const item = itms.find((v: any) => v.id === key);

    if (item) {
      onChangedItems(items.map((element, i) => (i === itemIndex ? { ...element, itemId: key } : element)));
    }
  };

  const onSelectContentPack = (id: string, index: number) => {
    onChangedItems(items.map((element, i) => (i === index ? { ...element, itemId: id } : element)));
  };

  return (
    <Card className="mt-3 mb-3">
      <Card.Body className="text-center">
        <Table bordered responsive hover>
          <thead className="text-center">
            <tr>
              <th>Level</th>
              <th>Type</th>
              <th>Item</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {items.map((item, itemIndex) => (
              <tr key={itemIndex}>
                <td className="align-middle">
                  <Editvalue
                    name="Level"
                    value={item?.itemLevel ?? ''}
                    handleValueChange={(lvl) =>
                      onChangedItems(
                        items.map((element, i) => (i === itemIndex ? { ...element, itemLevel: +lvl } : element))
                      )
                    }
                  />
                </td>
                <td className="align-middle">
                  <Form.Control
                    required
                    name="type"
                    as="select"
                    value={item.type}
                    onChange={(e) => {
                      onChangedItems(
                        items.map((element, i) =>
                          i === itemIndex
                            ? { ...element, type: e.target.value as CollectionItemType, itemId: '' }
                            : element
                        )
                      );
                    }}
                  >
                    {Object.keys(CollectionItemType).map((type) => (
                      <option value={type} key={type}>
                        {type}
                      </option>
                    ))}
                  </Form.Control>
                </td>
                <td className="align-middle">
                  {item.type === CollectionItemType.PLAYLIST ? (
                    <>
                      {item.itemId.length ? (
                        <div className="d-flex">
                          <Form.Control value={item.itemId} disabled />
                          <Button
                            variant="danger"
                            onClick={() => {
                              onChangedItems(
                                items.map((element, i) => (i === itemIndex ? { ...element, itemId: '' } : element))
                              );
                            }}
                          >
                            X
                          </Button>
                        </div>
                      ) : (
                        <AddContentPack
                          title="Select a Content Pack"
                          add={(selectedContentPack) => onSelectContentPack(selectedContentPack.id, itemIndex)}
                          curPacks={[]}
                          closeOnAdd
                        />
                      )}
                    </>
                  ) : (
                    <Form.Group>
                      {item.itemId.length ? (
                        <div className="d-flex">
                          <Form.Control value={item.itemId} disabled />
                          <Button
                            variant="danger"
                            onClick={() => {
                              onChangedItems(
                                items.map((element, i) => (i === itemIndex ? { ...element, itemId: '' } : element))
                              );
                            }}
                          >
                            X
                          </Button>
                        </div>
                      ) : (
                        <SelectAdd
                          buttonTitle={`Add ${item.type.toLowerCase()}`}
                          title={`Select ${item.type.toLowerCase()} to add`}
                          options={subItems[item.type]}
                          onAdd={(key) => onAdd(key, item.type, itemIndex)}
                        />
                      )}
                    </Form.Group>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Button variant="success" className="align-self-center" onClick={handleAddLevel}>
          Add an item
        </Button>
        <Button variant="danger" className="align-self-center ml-1" onClick={handleRemoveLevel}>
          Remove an item
        </Button>
      </Card.Body>
    </Card>
  );
}

export default CollectionLevelComponent;
